import React from "react";
import {
  FacebookShareButton,
  TwitterShareButton,
  LinkedinShareButton,
  WhatsappShareButton,
  EmailShareButton,
} from "react-share";
import {
  FaFacebook,
  FaLinkedin,
  FaWhatsappSquare,
  FaInstagram,
} from "react-icons/fa";
import { FaSquareXTwitter } from "react-icons/fa6";
import { MdEmail } from "react-icons/md";

const ShareSocialModal = ({ showModal, handleClose, url }) => {
  return (
    <div
      className={`modal fade ${showModal ? "show" : ""}`}
      tabIndex="-1"
      role="dialog"
      style={{
        backgroundColor: "rgba(0,0,0,0.5)",
        display: showModal ? "block" : "none",
      }}
    >
      <div
        className="modal-dialog"
        style={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          zIndex: 1050,
        }}
        role="document"
      >
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Share This URL</h5>
            <button
              type="button"
              className="close"
              data-dismiss="modal"
              aria-label="Close"
              onClick={handleClose}
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div className="modal-body">
            <div className="d-flex justify-content-around gap-3 flex-wrap">
              {/* Facebook */}
              <FacebookShareButton url={url} quote="Check this out!">
                <FaFacebook size={40} className="text-primary" />
              </FacebookShareButton>

              {/* Twitter */}
              <TwitterShareButton url={url} title="Check this out!">
                <FaSquareXTwitter size={40} className="text-black" />
              </TwitterShareButton>

              {/* LinkedIn */}
              <LinkedinShareButton url={url}>
                <FaLinkedin size={40} className="text-primary" />
              </LinkedinShareButton>

              {/* WhatsApp */}
              <WhatsappShareButton url={url} title="Check this out!">
                <FaWhatsappSquare size={40} className="text-success" />
              </WhatsappShareButton>

              {/* Instagram */}
              <a
                href="https://www.instagram.com/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaInstagram size={40} className="text-warning" />
              </a>

              {/* Email */}
              <EmailShareButton
                // url={url}
                subject="Check this out!"
                body={`Check this link: ${url}`}
              >
                <MdEmail size={40} className="text-danger" />
              </EmailShareButton>
            </div>
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-secondary"
              onClick={handleClose}
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ShareSocialModal;
